import slugify from "slugify";

export default function FormInput({
  label,
  required = false,
  error = false,
  description,
  type,
  ...params
}) {
  const identifier = slugify(label);

  return (
    <div className={`FormInput ${error ? "has-error" : ""}`}>
      <label className="FormLabel" htmlFor={identifier}>
        {label}
        {required && <span title="Pflichtfeld">*</span>}
      </label>
      <input
        className="Input"
        name={identifier}
        required={required}
        type={type}
        {...params}
        aria-describedby={description && `${identifier}-description`}
      />
      {description && (
        <p className="FormDescription" id={`${identifier}-description`}>
          {description}
        </p>
      )}
    </div>
  );
}
